import { Pipe, PipeTransform } from '@angular/core';
import { DropdownOptionService } from '../dropdowns/dropdown-option.service';

@Pipe({
  name: 'recruitingStatus'
})
export class RecruitingStatusPipe implements PipeTransform {
  private statusOptions;
  
  constructor(private dropdownOptionService: DropdownOptionService) {
    this.statusOptions = this.dropdownOptionService.recruitingStatus();
  }

  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    
    const statusString = value.toString();
    const option = this.statusOptions.find(opt => opt.value.toString() === statusString);
    
    return option ? option.label : `Status ${value}`;
  }
}